import {Component, OnInit} from '@angular/core';
import {SessionService, User} from '../../@core/session.service';
import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {Apollo} from 'apollo-angular';
import {MenuItem, MenuService, SubMenu} from '../../@core/menu.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

function normalizeIconName(icon: string): string {
  return icon?.endsWith('-o') ? icon.slice(0, -2) : icon;
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
  standalone: false
})
@UntilDestroy()
export class LayoutComponent implements OnInit {

  isCollapsed = false;
  user$: Observable<User>;
  menus: MenuItem[];
  showUserPanel = false;
  titles: string[] = [];
  title = '';

  constructor(private sess: SessionService, private apollo: Apollo,
              private menuSvr: MenuService, private router: Router) {
  }

  ngOnInit(): void {
    this.user$ = this.sess.getUser$();
    this.router.events.pipe(filter(v => v instanceof NavigationEnd)).subscribe(() => this.setTitle());
    this.menuSvr.getMenu$().pipe(untilDestroyed(this), filter(val => !!val))
      .subscribe(val => this.setMenus(val));
  }

  logout() {
    this.sess.signOut();
  }

  setMenus(val: MenuItem[]) {
    this.menus = val;
    this.menus.forEach(m => {
      m.icon = normalizeIconName(m.icon);
    });
    this.menus.forEach(m => {
      m.subMenus.forEach(s => {
        this.titles.push(`/${m.link}/${s.link}::${s.text}`);
      });
    });
    this.setTitle();
  }

  getUrlSegments(m: MenuItem, s: SubMenu): string[] {
    if (s.srims) {
      return ['/', 'forward'];
    }
    return ['/', m.link, ...s.link.split('/')];
  }

  getQueryParams(m: MenuItem, s: SubMenu): any {
    if (s.srims) {
      return {module: [m.link, ...s.link.split('/')].join('/')};
    }
    return {};

  }


  setTitle() {
    const currentUrl = this.router.url;
    const title = this.titles.find(t => t.startsWith(currentUrl));
    // TODO - title of child page
    this.title = title ? title.split('::')[1] : 'Welcome';
  }
}


